import { render, staticRenderFns } from "./CrossChainConfirmation.vue?vue&type=template&id=dd6c5c3a&scoped=true&"
import script from "./CrossChainConfirmation.vue?vue&type=script&lang=js&"
export * from "./CrossChainConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CrossChainConfirmation.vue?vue&type=style&index=0&id=dd6c5c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6c5c3a",
  null
  
)

export default component.exports